module.exports = "<div class=\"store-picker-delivery container\">\r\n\r\n    <h2 class=\"store-picker-delivery_title\">Change delivery address</h2>\r\n\r\n    <wow-store-locator-search is-delivery=\"isDelivery\" store-selected=\"storeSelected(store)\"></wow-store-locator-search>\r\n\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/storepicker/store-picker-delivery-template.html
 ** module id = 1034
 ** module chunks = 1
 **/